<div class="dialog-body">
    <ng-content></ng-content>
</div>